<template>
    <div class="job-role">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5">
                <h6 class="font-weight-bold kova-text mb-2 text-left">First name</h6>
                <div class="text-left">
                    <a-input class="mt-2" size="large" placeholder="First Name" />
                </div>  
                <h6 class="font-weight-bold kova-text mb-2 mt-4 text-left">Email</h6>
                <div class="text-left">
                    <a-input class="mt-2" size="large" placeholder="yourmail@domain.com" />
                </div>
                <h6 class="font-weight-bold kova-text mb-2 mt-4 text-left">Password</h6>
                <div class="text-left">
                    <a-input-password class="mt-2" size="large" placeholder="choose a password" />
                    <a-input class="mt-2" size="large" placeholder="retype password" />
                </div>
                <h6 class="font-weight-bold kova-text mb-2 mt-4 text-left">Skype ID or Phone</h6>
                <div class="text-left">
                    <a-input placeholder="9012345678" size="large" style="color: #000">
                        <a-select slot="addonBefore" default-value="234" style="width: 80px">
                        <!-- <a-select-option v-for="code in countries" :key="code.callingCodes[0]" :value="code.callingCodes[0]">
                            {{code.callingCodes[0]}}
                        </a-select-option> -->
                        <a-select-option v-for="code in countriesCode" :key="code" :value="code">
                            {{code}}
                        </a-select-option>
                        </a-select>
                    </a-input>
                </div>
                <h6 class="font-weight-bold kova-text mb-2 mt-4 text-left">Time Zone and Location</h6>
                <div class="text-left">
                     <a-select default-value="West Africa" class="w-100" size="large">
                        <a-select-option v-for="country in countries" :key="country" :value="country">
                            {{country}}
                        </a-select-option>
                    </a-select>
                </div>             
                <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" @click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" @click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
 </div>
</template>
<script>

export default {
    name: 'job-role',
    components: {
        
    },
    data(){
        return {
            htmlForEditor: "",
            devSkills: [],
            skills: [
                'Android', 'IOS', 'CyberSecurity','Data Engineering', 'eCommerce', 'Web Application','Front-end',
                'Back-end', 'UI/UX', 'Artificial Intelligence', 'Blockchain', 'Integration', 'Project management',
                'DApps', 'DevOps'
            ],
            countries: ['West Africa GMT + 1', 'East Africa', 'South America'],
            countriesCode: ['1', '44', '234', '233', '81']
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push({path:'stack'})
        },
        skip(){
            this.$router.push({path:'stack'})
        },
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        
            var formData = new FormData();
            formData.append("file", file);
        
            this.$http({
                url: "https://fakeapi.yoursite.com/images",
                method: "POST",
                data: formData
            })
            .then(result => {
            let url = result.data.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "file", url);
            resetUploader();
            })
            // .catch(err => {
            // console.log(err);
            // });
        }
    },
     mounted(){
    //     this.$http({
    // method:"GET",
    // url:"https://restcountries-v1.p.rapidapi.com/all",
    // headers:{
    // // "content-type":"application/octet-stream",
    // "x-rapidapi-host":"restcountries-v1.p.rapidapi.com",
    // "x-rapidapi-key": "31bb44eb39msh97934b575e1fcf2p1ebc09jsn6180036af03e",
    // "access-control-allow-origin": "*",
    // "useQueryString":true,
    // 'Content-Type': 'application/json'
    // },
    // crossdomain: true
    // })
    // .then((response)=>{
    //   console.log(response.json())
    // })
    // .catch((error)=>{
    //   console.log(error)
    // })

    // fetch("https://restcountries-v1.p.rapidapi.com/all", {
    //     "method": "GET",
    //     "headers": {
    //         "x-rapidapi-host": "restcountries-v1.p.rapidapi.com",
    //         "x-rapidapi-key": "31bb44eb39msh97934b575e1fcf2p1ebc09jsn6180036af03e"
    //         }
    //     })
    //     .then(response => response.json())
    //     .then(data => {
    //         console.log(data)
    //         data.map(item => {
    //             this.countries.push({country: item.name, currencies: item.currencies, callingCodes: item.callingCodes, timezones: item.timezones})
    //             })
    //         console.log(this.countries)
    //     })
    //     .catch(err => {
    //         console.log(err);
    //     });
//         ({
//             method: 'GET',
//             url:'https://salnazi-country-codes-v1.p.rapidapi.com/api.php?apiKey=8923sa7aAS7s&secret=us7uS78sj%3Fapikey%3D8923sa7aAS7s&secret=us7uS78sj',
//             headers: {
//                 "x-rapidapi-host": "salnazi-country-codes-v1.p.rapidapi.com","x-rapidapi-key": "6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d"
//             }
//         }).then((response) => {
//             this.countries = response.data
//             console.log(response.data)
//             console.log("data")

//         });
//         fetch("https://salnazi-country-codes-v1.p.rapidapi.com/api.php?apiKey=8923sa7aAS7s&secret=us7uS78sj%3Fapikey%3D8923sa7aAS7s&secret=us7uS78sj", {
// 	"method": "GET",
// 	"headers": {
// 		"x-rapidapi-host": "salnazi-country-codes-v1.p.rapidapi.com",
// 		"x-rapidapi-key": "6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d"
// 	}
// })
// .then(response => {
// 	console.log(response);
// })
// .catch(err => {
// 	console.log(err);
// });
    }
}
</script>
<style scoped>

</style>
